<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? $t(`GROUPVIEW.listGroups`) : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <group-list/>
      </div>
    </vs-tab>

    <vs-tab v-if="checkCrud(rol, 'create')" icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? $t(`GROUPVIEW.newGroup`) : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <group-form/>
      </div>
    </vs-tab>

  </vs-tabs>
</template>

<script>
import GroupList from './GroupList';
import GroupForm from './newGroupForm.vue';
import { _Permissions } from "../../acl/permitions";

export default {
  mixins: [_Permissions],
  components: {
    GroupList,
    GroupForm,
  },
  data () {
    return {
    }
  },
  computed: {
    rol() {
      return this.$store.state.user.roleName;
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
